import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { Link } from "@brexhq/next/src/components/shared/Link";

const StyledLink = styled(Link)(({ theme }) => ({
  ...theme.typography.BodySmallSB,
  ...padding(theme.spacing.SML.xsml, theme.spacing.SML.sml),
  borderBottom: `1px solid ${theme.colors.border.default}`,
  width: "100%",
  color: `${theme.colors.content.primary}`,
  "&:hover": {
    color: `${theme.colors.content.primary}`,
  },
}));

interface Props {
  to: string;
  children: string;
  noFollow?: boolean | null;
}

export default function ItemLink({ to, children, noFollow }: Props) {
  const { colors } = useTheme();
  return (
    <StyledLink
      modifier="unstyled"
      to={to}
      noFollow={noFollow}
      label={children}
      component="Mobile nav menu link"
      color={colors.content.primary}
    >
      {children}
    </StyledLink>
  );
}
